/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartResponse
 */
export interface PartResponse {
    /**
     * 
     * @type {number}
     * @memberof PartResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PartResponse
     */
    partTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof PartResponse
     */
    manufacturerId?: number;
    /**
     * 
     * @type {string}
     * @memberof PartResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PartResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PartResponse
     */
    partNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PartResponse
     */
    externalId?: string;
}

/**
 * Check if a given object implements the PartResponse interface.
 */
export function instanceOfPartResponse(value: object): value is PartResponse {
    return true;
}

export function PartResponseFromJSON(json: any): PartResponse {
    return PartResponseFromJSONTyped(json, false);
}

export function PartResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'partTypeId': json['partTypeId'] == null ? undefined : json['partTypeId'],
        'manufacturerId': json['manufacturerId'] == null ? undefined : json['manufacturerId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'partNumber': json['partNumber'] == null ? undefined : json['partNumber'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
    };
}

export function PartResponseToJSON(json: any): PartResponse {
    return PartResponseToJSONTyped(json, false);
}

export function PartResponseToJSONTyped(value?: PartResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'partTypeId': value['partTypeId'],
        'manufacturerId': value['manufacturerId'],
        'name': value['name'],
        'description': value['description'],
        'partNumber': value['partNumber'],
        'externalId': value['externalId'],
    };
}

